import React from 'react';
import PropTypes from 'prop-types';
import './card.scss';

const Card = ({ className, image, size, link, content, contentPosition, onClick = () => { } }) => {
  const renderChildren = () => {
    return (
      <>
        {image}
        {content && (
          <section className={`card__content card__content--${size}`}>
            {content}
          </section>
        )}
      </>
    );
  };

  const baseClassName = `card__wrapper card__wrapper--${contentPosition}`;

  return (link ? (
    <a
      onClick={onClick}
      onAuxClick={onClick}
      className={
        className ? className + ' ' + baseClassName : baseClassName
      }
      href={link}
    >
      {renderChildren()}
    </a>
  ) : (
    <section
      onClick={onClick}
      onAuxClick={onClick}
      className={
        className ? className + ' ' + baseClassName : baseClassName
      }
    >
      {renderChildren()}
    </section>
  )
  );
};

export const CardSizes = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'x-large',
  full: 'full',
};

export const CardContentPosition = {
  top: 'content-top',
  right: 'content-right',
  bottom: 'content-bottom',
  left: 'content-left',
};

Card.propTypes = {
  className: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
  size: PropTypes.oneOf(Object.values(CardSizes)),
  link: PropTypes.string,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]).isRequired,
  contentPosition: PropTypes.oneOf(Object.values(CardContentPosition)),
};

Card.defaultProps = {
  className: '',
  image: null,
  size: CardSizes.large,
  link: null,
  content: null,
  contentPosition: CardContentPosition.right,
};

export default Card;
